export default __webpack_public_path__ + "static/media/Kahsh-Icon.bb47a00f.svg";